import { getLocale } from './getLocale'

const formatter = new Intl.NumberFormat(getLocale(), {
	style: 'currency',
	currency: 'EUR',
	minimumFractionDigits: 0,
	maximumFractionDigits: 2,
})

export function formatCurrency(amount: number): string {
	return formatter.format(amount)
}
